import React from "react";

import "./App.css";
import Header from "./components/Header";
import Home from "./components/Home";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Detail from "./components/Detail";
import Footer from "./components/Footer";
import Login from "./components/Login";
import MoviesDh from "./components/MoviesDh";
import Search from "./components/Search";
import Series from "./components/Series";
import ContextProvider from "./store/contextProvider";

const App = () => {
	return (
		<ContextProvider>
			<Router>
				<Header />
				<Routes>
					<Route path="/" exact element={<Home />} />
					<Route path="/login" element={<Login />} />
					<Route path="/Detail" element={<Detail />} />
					<Route path="/movies" element={<MoviesDh />} />
					<Route path="/series" element={<Series />} />
					<Route path="/search" element={<Search />} />
					<Route path="*" element={<Navigate to={"/"} />} />
				</Routes>
				<Footer />
			</Router>
		</ContextProvider>
	);
};

export default App;
